<template>
  <div class="chat-item-default my-1" :class="{me: isMine}">
    <small v-if="isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
    <span class="px-2 py-1">{{ $t("pc_connection_created") }}</span>
    <small v-if="!isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss">
.chat-item-default {
  width: 100%;

  span {
    background-color: #eee;
    border-radius: 0.9em;
    font-size: 0.8em;
    font-weight: normal;
    display: inline-block;
  }
  small {
    font-size: 0.65em;
  }
  &.me {
    text-align: right;
    span {
      background-color: #3c88ff;
      color: #fff;
    }
  }
}
</style>
<i18n>
{
  "ka": {
        "pc_connection_created":"გახსნილია კავშირი კლინიკასა და პაციენტს შორის"
  },
  "en": {
        "pc_connection_created":"Connection created between clinic and patient"
  }
}
</i18n>
